export const formatDate = (createdAt: string | Date) => {
  const date = new Date(createdAt)
  const day = String(date.getUTCDate()).padStart(2, "0")
  const month = String(date.getUTCMonth() + 1).padStart(2, "0")
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, "0")
  const minutes = String(date.getUTCMinutes()).padStart(2, "0")
  const seconds = String(date.getUTCSeconds()).padStart(2, "0")

  const formattedTime = `${hours}:${minutes}:${seconds}`
  const formattedDate = `${day}/${month}/${year}`
  return { formattedDate, formattedTime }
}

export const formatDatePost = (dateString: string) => {
  const date = new Date(dateString)

  const dateOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }

  const formattedDate = date.toLocaleDateString("en-GB", dateOptions)
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions)

  return `${formattedDate} ${formattedTime}`
}
